import React, {useEffect, useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import moment from "moment";
import axios from "../../../helpers/axios";
import sayError from "../../../helpers/sayError";
import {useSelector} from "react-redux";
import {noDispHeader} from "../../../helpers/errorTranslate";
import BlockUi from "@availity/block-ui";
import {useNavigate} from "react-router";
import {TouristServicesCreateRoute} from "../../routesConstants";
import _ from "lodash"
import DatePicker from "react-datepicker";
import LoadingButton from "../../base/components/loadingButton";
import ApiSelect from "../../base/components/forms/apiSelect";

const RustarParseModal = ({orderBase, show, close}) => {
  const { id } = useSelector(state => state.auth.user);
  const [parseInput, setParseInput] = useState('')
  const [loading, setLoading] = useState(false)
  const [order, setOrder]= useState(orderBase)



  const onPasteAction = async event => {
    setLoading(true)
    const text = event.clipboardData.getData("Text");
    if (text) {
      axios.post('/api/touristServices/rustar/parseInv',
        {...order, text},
        {headers: {...noDispHeader}})
        .then(({data})=>{
          localStorage.setItem('potentialBuyers', JSON.stringify(data.data.potentialBuyers))
          data.data.invoice.ussuedBy = id
          localStorage.setItem('servCopied', JSON.stringify(data.data.invoice))
          window.open(TouristServicesCreateRoute,'_blank')
          close()
          setOrder()
        })
        .catch(sayError)
        .finally(()=>{
          setLoading(false)
        })
      setLoading(false)
    }
  };
  return (
    <>
      <Modal show={show} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>
            Парс брони №{order?.orderId||''}
          </Modal.Title>
        </Modal.Header>
        <BlockUi blocking={loading}>
          <Modal.Body>
            <div className={'mb-2'}>
              <div>
                Выбирите город до вставки текста
                <ApiSelect
                  value={order.city || ''}
                  url={"/api/locations/cities/searchInput"}
                  allInfo
                  cb={newVal => {
                    setOrder(q => ({...q, city: newVal.value, country:newVal.country}))
                  }
                  }
                />
              </div>
              <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
                <input
                  defaultChecked={false}
                  checked={!!order.withTransfers}
                  onChange={(e) => {
                    setOrder(q => ({...q, withTransfers: e.target.checked}))
                  }}
                  type={"checkbox"}
                />
                Загружать с транферами
              </Form.Label>

            </div>
            <Form.Control
              as="textarea"
              autoFocus
              rows="20"
              value={parseInput}
              onPaste={onPasteAction}
              onChange={newVal => setParseInput(newVal.target.value)}
            />
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton variant="secondary" title={"Закрыть"} onClick={close} loading={loading}/>
          </Modal.Footer>
        </BlockUi>
      </Modal>
    </>

  );
};

export default RustarParseModal;
